// extracted by mini-css-extract-plugin
export default {"add_sos_button":"SOSTab_add_sos_button__U5vSh"};